import * as React from 'react';
import { TextField } from '@mui/material';


export default function TextInput({
    label,
    name,
    value,
    changeHandler,
    error=false,
    helperText=false,
    width=false,
    className=''
}) {

    return (
        <TextField
            sx={{ 
                width: { 
                    xs: '100%', 
                    sm:width === false ? '30%':'100%',  
                    md:width === false ? '24%':'100%' 
                } 
            }}   
            className={className}
            margin="dense"
            id={name}
            label={label}
            name={name}
            value={value || ''}
            onChange={changeHandler}
            error={error && value === ""}
            helperText={helperText && value === "" ? "Required Field!" : false}
        />
    )
}